import { Injectable } from '@angular/core';
declare let THREE: any;

@Injectable()
export class WallConnectionService {

  constructor() { }

  

  plane = new THREE.Plane();
  ray = new THREE.Ray();

  connectAllWalls(walls) {
      var count = walls.length,
          i = 0,
          currentWall,
          nextWall;

      for (; i < count; i++) {
          currentWall = walls[i];
          nextWall = walls[(i + 1) % count];
          this.connectTwoWalls(currentWall, nextWall);
      }
  };

  moveWallAVertices(wall, position) {
      /*
        vertex[1] - back top right
        vertex[3] - back bottom right
       */

      var geometry = wall.geometry;

      geometry.vertices[3].x = position.x;
      geometry.vertices[3].z = position.z;
      geometry.vertices[1].x = position.x;
      geometry.vertices[1].z = position.z;
      geometry.verticesNeedUpdate = true;
      geometry.boundingSphere = null;
      geometry.boundingBox = null;
  };

  moveWallBVertices(wall, position) {
      /*
       vertex[4] - back left top 
        vertex[6] - back left bottom 
       */

      var geometry = wall.geometry;

      geometry.vertices[6].x = position.x;
      geometry.vertices[6].z = position.z;
      geometry.vertices[4].x = position.x;
      geometry.vertices[4].z = position.z;
      geometry.verticesNeedUpdate = true;
      geometry.boundingSphere = null;
      geometry.boundingBox = null;
  };

  connectTwoWalls(wallA, wallB) {

      wallA.updateMatrixWorld();
      wallB.updateMatrixWorld();

      var currentPoint = wallA.localToWorld(new THREE.Vector3(wallA.geometry.vertices[2].x, 0, 0)),
          prevPoint = wallA.localToWorld(new THREE.Vector3(0, 0, 0)),
          currentWallDir = wallA.getWorldDirection(new THREE.Vector3()),
          nextWallDirection = wallB.getWorldDirection(new THREE.Vector3()),
          wallAWidth = wallA.userData.entity.width,
          wallBWidth = wallB.userData.entity.width,
          wallAPoint,
          wallBPoint,
          planePosition,
          upVector,
          rayDir,
          rayOrigin,
          angle,
          sign = 1,
          intersectionPoint,
          dotProduct = currentWallDir.dot(nextWallDirection);

      if (dotProduct >= 0.995 && dotProduct <= 1.01) {
          var direction = currentWallDir.clone().negate();
          wallAPoint = wallA.worldToLocal(direction.clone().multiplyScalar(wallAWidth).add(currentPoint));
          wallBPoint = wallB.worldToLocal(direction.multiplyScalar(wallBWidth).add(currentPoint));
          this.moveWallAVertices(wallA, wallAPoint);
          this.moveWallBVertices(wallB, wallBPoint);
      }
      else {

          currentWallDir.negate();
          nextWallDirection.negate();
          planePosition = nextWallDirection.clone().multiplyScalar(wallBWidth).add(currentPoint);
          rayOrigin = currentWallDir.clone().multiplyScalar(wallAWidth).add(prevPoint);
          upVector = new THREE.Vector3(0, 1, 0);
          angle = ((Math.atan2(nextWallDirection.x, nextWallDirection.z) -
              Math.atan2(currentWallDir.x, currentWallDir.z) + Math.PI * 2) % (Math.PI * 2)) - Math.PI;
          sign = -1;

          rayDir = currentWallDir.clone().applyAxisAngle(upVector, Math.PI / 2 * sign);
          this.plane.setFromNormalAndCoplanarPoint(nextWallDirection, planePosition);
          this.ray.set(rayOrigin, rayDir);

          intersectionPoint = this.ray.intersectPlane(this.plane);

          if (intersectionPoint) {
              wallAPoint = wallA.worldToLocal(intersectionPoint.clone());
              wallBPoint = wallB.worldToLocal(intersectionPoint);
              this.moveWallAVertices(wallA, wallAPoint);
              this.moveWallBVertices(wallB, wallBPoint);
          }
      }
  };



}



// WEBPACK FOOTER //
// ./src/app/services/wall-connection.service.ts